module.exports = __webpack_public_path__ + "static/media/fendlogo.0424f1be.svg";